import { render, staticRenderFns } from "./Zoom.vue?vue&type=template&id=6d2ec9fc&scoped=true"
import script from "./Zoom.vue?vue&type=script&lang=js"
export * from "./Zoom.vue?vue&type=script&lang=js"
import style0 from "./Zoom.vue?vue&type=style&index=0&id=6d2ec9fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ec9fc",
  null
  
)

export default component.exports